<section class="dashboard-hero" aria-labelledby="dashboard-hero-title">
  <div class="dashboard-hero__container">
    <div class="dashboard-hero__content">
      <div class="dashboard-hero__heading">
        @if(content.imageUrl){
          <span class="dashboard-hero__icon" aria-hidden="true">
            <img [src]="content.imageUrl" alt="" class="dashboard-hero__icon-image">
          </span>
        }
        <h1 id="dashboard-hero-title" class="dashboard-hero__title">{{ content.title }}</h1>
      </div>

      <p class="dashboard-hero__text">
        {{ content.subtitle }}
      </p>
    </div>
  </div>
</section>
